const UserVoice = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12C10.28 12 12 10.28 12 7.99999C12 5.71999 10.28 3.99999 8 3.99999C5.72 3.99999 4 5.71999 4 7.99999C4 10.28 5.72 12 8 12ZM8 5.99999C9.178 5.99999 10 6.82199 10 7.99999C10 9.17799 9.178 9.99999 8 9.99999C6.822 9.99999 6 9.17799 6 7.99999C6 6.82199 6.822 5.99999 8 5.99999ZM9 13H7C4.243 13 2 15.243 2 18V19H4V18C4 16.346 5.346 15 7 15H9C10.654 15 12 16.346 12 18V19H14V18C14 15.243 11.757 13 9 13ZM18.364 2.63599L16.95 4.04999C18.271 5.37299 19 7.13099 19 8.99999C19 10.869 18.271 12.627 16.95 13.95L18.364 15.364C20.064 13.663 21 11.403 21 8.99999C21 6.59699 20.064 4.33699 18.364 2.63599Z"
        fill={color}
      />
      <path
        d="M15.5351 5.46411L14.1211 6.88011C14.6881 7.44511 15.0001 8.19811 15.0001 9.00011C15.0001 9.80211 14.6881 10.5551 14.1211 11.1201L15.5351 12.5361C16.4791 11.5921 17.0001 10.3371 17.0001 9.00011C17.0001 7.66311 16.4791 6.40811 15.5351 5.46411Z"
        fill={color}
      />
    </svg>
  );

  const solid = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.052C9.995 12.052 11.5 10.547 11.5 8.55199C11.5 6.55699 9.995 5.05199 8 5.05199C6.005 5.05199 4.5 6.55699 4.5 8.55199C4.5 10.547 6.005 12.052 8 12.052ZM9 13H7C4.243 13 2 15.243 2 18V19H14V18C14 15.243 11.757 13 9 13ZM18.364 2.63599L16.95 4.04999C18.271 5.37299 19 7.13099 19 8.99999C19 10.869 18.271 12.627 16.95 13.95L18.364 15.364C20.064 13.663 21 11.403 21 8.99999C21 6.59699 20.064 4.33699 18.364 2.63599Z"
        fill={color}
      />
      <path
        d="M15.5351 5.46411L14.1211 6.88011C14.6881 7.44511 15.0001 8.19811 15.0001 9.00011C15.0001 9.80211 14.6881 10.5551 14.1211 11.1201L15.5351 12.5361C16.4791 11.5921 17.0001 10.3371 17.0001 9.00011C17.0001 7.66311 16.4791 6.40811 15.5351 5.46411Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default UserVoice;
